require('./OKWizardSummary.scss');

// @vendors
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @helpers
import { formatAmountObject } from 'utilities/currencyHelper';
const PersonalDataHelper = require('utilities/personalDataHelper');
import { getLastNChars } from 'utilities/stringHelper';
import { i18n } from 'core/i18n';
const { FormattedText, formatText, getLanguage } = i18n;

// @components
import { OKSectionBox } from 'commonsComponents/OKSectionBox';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');

const { ES_COUNTRY } = require('constants/flagBasedFeatures');

// @constants
import {
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_VARIABLE,
    EURO_TEXT,
    HYPHEN,
    LIMIT_CHARITY_AMOUNT
} from 'constants/index';


const CREDIT_LABELS = [
    'selectedNameForCard',
    'selectedLimit',
    'paymentMethod',
    'paymentMethodAmount',
    'tin',
    'tae',
    'separator',
    'selectedAccount'
];

const SOLIDARITY_LABELS = [
    'selectedNameForCard',
    'ong',
    'solidarityCardLimits',
    'separator',
    'selectedAccount'
];

class OKSummaryHireCard extends Component {

    buildExtraImageContent() {
        const { extraImage, extraImageById } = this.props;
        let content;

        if (Boolean(extraImage)) {
            const extraImageSrc = extraImageById.getIn([extraImage, 'url']);
            content = (
                <div className="ok-summary-hire-card__extra-image-container">
                    <img
                        src={extraImageSrc}
                        className="ok-summary-hire-card__extra-image"
                    />
                </div>
            );
        }

        return content;
    }

    buildImageContent() {
        const { selectedImageId, selectedImageFetchSuccess, imagesById, showCardIBAN, immCard } = this.props;

        let content;
        if (!showCardIBAN) {
            if (selectedImageFetchSuccess && Boolean(selectedImageId)) {
                const imgSrc = imagesById.getIn([selectedImageId, 'url']);
                const extraImageElement = this.buildExtraImageContent();

                content = (
                    <div className="ok-summary-hire-card__image-container">
                        {extraImageElement}
                        <img className="ok-summary-hire-card__image" src={imgSrc} />
                    </div>
                );
            }
        } else {
            content = (
                <div className="ok-summary-hire-card__image-container-iban">
                    <CommercialAds path="cards" type="cards" immCard={immCard} />
                </div>
            )
        }

        return content;
    }

    buildFieldsContent() {
        const { type, hirePaymentMethodType } = this.props;

        switch (type) {
            case 'credit':
                return CREDIT_LABELS.map( (label, index) => {
                    const CREDIT_LABELS_OPTIONAL = ['paymentMethodAmount', 'tin', 'tae'];

                    if ( (!hirePaymentMethodType || hirePaymentMethodType === CARD_PAYMENT_METHOD_UNIQUE)
                        && CREDIT_LABELS_OPTIONAL.includes(label)) {
                        return;
                    }

                    if (label === 'separator') {
                        return <div key={index} className="ok-summary-hire-card__separator" />;
                    } else {
                        const value = this.getFieldValue(label);

                        let valueContent;
                        if (Boolean(value)) {
                            valueContent = (
                                <div className="ok-summary-hire-card__value">
                                    {value}
                                </div>
                            );
                        } else {
                            valueContent = (
                                <div className="ok-summary-hire-card__pending-value">
                                    <FormattedText value="hireCardSidebar-pendingValue" />
                                </div>
                            );
                        }

                        return (
                            <section key={index} className="ok-summary-hire-card__field">
                                <FormattedText
                                    value={`hireCardSidebar-${label}`}
                                    className="ok-summary-hire-card__label"
                                />
                                {valueContent}
                            </section>
                        );
                    }
                });
            case 'solidarity':
                return SOLIDARITY_LABELS.map( (label, index) => {
                    const SOLIDARITY_LABELS_OPTIONAL = [];

                    if ( (!hirePaymentMethodType || hirePaymentMethodType === CARD_PAYMENT_METHOD_UNIQUE)
                        && SOLIDARITY_LABELS_OPTIONAL.includes(label)) {
                        return;
                    }

                    if (label === 'separator') {
                        return <div key={index} className="ok-summary-hire-card__separator" />;
                    } else {
                        const value = this.getFieldValue(label);
                        let valueContent;

                        if (Boolean(value)) {
                            if (label !== 'ong') {
                                valueContent = (
                                    <div className="ok-summary-hire-card__value">
                                        {value}
                                    </div>
                                );
                            } else {
                                if (value.size === 0) {
                                    valueContent = (
                                        <div className="ok-summary-hire-card__pending-value">
                                            <FormattedText value="hireCardSidebar-pendingValue" />
                                        </div>
                                    );
                                } else {
                                    valueContent = (
                                        <div className="ok-summary-hire-card__value">
                                            {value}
                                        </div>
                                    );
                                }
                            }
                        } else {
                            valueContent = (
                                <div className="ok-summary-hire-card__pending-value">
                                    <FormattedText value="hireCardSidebar-pendingValue" />
                                </div>
                            );
                        }

                        return (
                            <section key={index} className="ok-summary-hire-card__field">
                                <FormattedText
                                    value={`hireCardSidebar-${label}`}
                                    className="ok-summary-hire-card__label"
                                />
                                {valueContent}
                            </section>
                        );
                    }
                });
            default:
                return null;
        }
    }

    getFieldValue(label) {
        const {
            creditType,
            immAccountsById,
            openCreditAplazadoTIN,
            diamondAplazadoTIN,
            premiumAplazadoTIN,
            openCreditAplazadoTAE,
            diamondAplazadoTAE,
            premiumAplazadoTAE,
            hireCreditLimit,
            hireCreditLimitFetchSuccess,
            hirePaymentMethodType,
            hirePaymentMethodValue,
            selectedAccount,
            immHireCardNameSelector,
        } = this.props;

        switch (label) {
            case 'selectedNameForCard':
                return immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')]);
            case 'selectedAccount':
                if (Boolean(selectedAccount)) {
                    const immAccount = immAccountsById.get(selectedAccount);
                    const accountIban = getLastNChars(immAccount.get('iban'));
                    return (
                        <div>
                            <span>{immAccount.get('alias')}</span>
                            &nbsp;
                            <span>{accountIban}</span>
                        </div>
                    );
                } else {
                    return selectedAccount;
                }
            case 'selectedLimit':
                if (hireCreditLimitFetchSuccess) {
                    const amountObj = {
                        amount: hireCreditLimit,
                        currency: EURO_TEXT
                    };

                    return (
                        <div className="ok-summary-hire-card__value--important">
                            <OneLineSymbolAmount
                                amountObject={amountObj}
                                language={getLanguage()}
                                amountObjectFormatted={formatAmountObject(amountObj, true)}
                            />
                        </div>
                    );
                } else {
                    return '';
                }
            case 'paymentMethod':
                if (Boolean(hirePaymentMethodType)) {
                    const paymentMethod = {
                        [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('hireCardSidebar-methodOfPaymentFullPay')}`,
                        [CARD_PAYMENT_METHOD_FIXED]: `${formatText('hireCardSidebar-methodOfPaymentDeferredFixedFee')}`,
                        [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('hireCardSidebar-methodOfPaymentDeferredVariableFee')}`
                    };
                    return paymentMethod[hirePaymentMethodType];

                } else {
                    return '';
                }
            case 'paymentMethodAmount':
                if (hirePaymentMethodType === CARD_PAYMENT_METHOD_FIXED) {
                    const amountObj = {
                        amount: hirePaymentMethodValue,
                        currency: EURO_TEXT
                    };

                    return (
                        <OneLineSymbolAmount
                            amountObject={amountObj}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(amountObj, true)}
                        />
                    );
                } else if (hirePaymentMethodType === CARD_PAYMENT_METHOD_VARIABLE) {
                    return `${hirePaymentMethodValue} %`;
                } else {
                    return '';
                }
            case 'tin':
                const tinValues = {
                    'open-credit': openCreditAplazadoTIN,
                    'diamond': diamondAplazadoTIN,
                    'premium': premiumAplazadoTIN
                };
                return tinValues[creditType];
            case 'tae':
                const taeValues = {
                    'open-credit': openCreditAplazadoTAE,
                    'diamond': diamondAplazadoTAE,
                    'premium': premiumAplazadoTAE
                };
                return taeValues[creditType];

            case 'ong':
                if (this.props.ong) {
                    return this.props.ong.map((foundation, index) => {
                        // return <img key={index} style={{ marginTop: '20px', display: 'block', maxWidth: '100%', maxHeight: '40px' }} src={foundation.getIn(['suggestion', 'logo'])} />;
                        return !this.props.modifyCharity
                            ?
                            <div key={index}>{foundation.getIn(['suggestion', 'name'])}</div>
                            :
                            <div key={index}>{foundation.suggestion.name}</div>
                    });
                }
                return undefined;
            case 'solidarityCardLimits':
                const min = this.props.solidarityCardLimits.min;
                const max = this.props.solidarityCardLimits.max;
                const maxAmountValue = max === LIMIT_CHARITY_AMOUNT ? formatText('ngoAmounts-maxLimit') : max;

                if (this.props.solidarityCardLimits.min || this.props.solidarityCardLimits.max) {
                    return (
                        <Fragment>
                            <div>
                                <FormattedText value="common-minimumLimit" />:&nbsp;
                                <span>{`${min} €/`}<FormattedText
                                    value="common-month"
                                    format="lowercase"
                                /></span>
                            </div>
                            <div>
                                <FormattedText value="common-maximumLimit" />:&nbsp;
                                <Fragment>
                                    {max === LIMIT_CHARITY_AMOUNT ? maxAmountValue : `${maxAmountValue}€/`}
                                    {max !== LIMIT_CHARITY_AMOUNT && <FormattedText
                                        value="common-month"
                                        format="lowercase"
                                    />}
                                </Fragment>
                            </div>
                        </Fragment>
                    );
                }
                return undefined;
            default:
                return '';
        }
    }

    buildAddressContent() {
        const { 
            addressContent, 
            immAddress, 
            immProfile, 
            hasShippingAddress,
            immShippingAddressList,
            flagBasedFeatures
        } = this.props;

        let content;
        if (hasShippingAddress && immAddress) {
            const originCountry = immProfile.get('originCountry');
            if (!flagBasedFeatures.get(ES_COUNTRY)) {
                const shippingAddress = (immAddress.isEmpty()) ? HYPHEN : PersonalDataHelper.getHireFormattedShippingAddress(immShippingAddressList, originCountry);
                content = <p>{shippingAddress}</p>;
            } else {
                const shippingAddress = (immAddress.isEmpty()) ? HYPHEN : PersonalDataHelper.getHireFormattedAddress(immAddress);
                content = (
                    <p>{shippingAddress}</p>
                );
            }
        } else {
            if (immProfile.get('isFetching')) {
                content = <LoadingSection />;
            } else {
                content = (
                    <p>{addressContent}</p>
                );
            }
        }

        return (
            <section className="ok-summary-hire-card__field">
                <FormattedText value="hireCardSidebar-shippingAddress" className="ok-summary-hire-card__label" />
                <div className="ok-summary-hire-card__value">
                    {content}
                </div>
            </section>
        );
    }

    render() {
        const { showAddress } = this.props;
        const imageContent = this.buildImageContent();
        const addressContent = this.buildAddressContent();
        const fieldsContent = this.buildFieldsContent();

        return (
            <OKSectionBox className="ok-summary-hire-card">
                <section>
                    <h3 className="ok-summary-hire-card__title">
                        <FormattedText value="hireCardSidebar-title" />
                    </h3>
                    {imageContent}
                    {fieldsContent}
                    <div className="ok-summary-hire-card__separator" />
                    {showAddress && addressContent}
                </section>
            </OKSectionBox>
        );
    }
}

OKSummaryHireCard.propTypes = {
    addressContent: PropTypes.string.isRequired,
    creditType: PropTypes.oneOf(['solidarity-card', 'open-credit', 'diamond', 'premium']),
    diamondAplazadoTAE: PropTypes.string.isRequired,
    diamondAplazadoTIN: PropTypes.string.isRequired,
    extraImage: PropTypes.string,
    extraImageById: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    hasShippingAddress: PropTypes.bool.isRequired,
    hireCreditLimit: PropTypes.string.isRequired,
    hireCreditLimitFetchSuccess: PropTypes.bool.isRequired,
    hirePaymentMethodType: PropTypes.string.isRequired,
    hirePaymentMethodValue: PropTypes.string.isRequired,
    imagesById: PropTypes.object.isRequired,
    immAccountsById: PropTypes.object.isRequired,
    immAddress: PropTypes.object.isRequired,
    immCard: PropTypes.obj,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object,
    modifyCharity: PropTypes.bool.isRequired,
    ong: PropTypes.array,
    openCreditAplazadoTAE: PropTypes.string.isRequired,
    openCreditAplazadoTIN: PropTypes.string.isRequired,
    paymentMethod: PropTypes.string,
    premiumAplazadoTAE: PropTypes.string.isRequired,
    premiumAplazadoTIN: PropTypes.string.isRequired,
    selectedAccount: PropTypes.string,
    selectedImageFetchSuccess: PropTypes.bool.isRequired,
    selectedImageId: PropTypes.string.isRequired,
    selectedLimit: PropTypes.string,
    showAddress: PropTypes.bool,
    showCardIBAN: PropTypes.bool,
    solidarityCardLimits: PropTypes.object,
    type: PropTypes.oneOf(['credit', 'debit', 'solidarity']),
};

OKSummaryHireCard.defaultProps = {
    type: 'credit',
    creditType: 'open-credit',
    modifyCharity: false,
    showAddress: true,
    showCardIBAN: false
};

export const OKSummaryHireCardC = connect(
    state => ({
        diamondAplazadoTAE: state.globalVariables.getIn(['variables', 'parameters', 'pack_diamond', 'aplazado_tae']),
        diamondAplazadoTIN: state.globalVariables.getIn(['variables', 'parameters', 'pack_diamond', 'aplazado_tin']),
        extraImageById: state.hireCardImageSelector.get('extraImageById'),
        flagBasedFeatures: state.flagBasedFeatures,
        // hireCreditLimit: state.hireCreditLimit.get('creditLimit'),
        hireCreditLimit: 0, // Pending from changes in dev.
        // hireCreditLimitFetchSuccess: state.hireCreditLimit.get('fetchSuccess'),
        hireCreditLimitFetchSuccess: true, // Pending from changes in dev.
        // hirePaymentMethodType: state.hirePaymentMethod.get('type'),
        hirePaymentMethodType: '', // Pending from changes in dev.
        // hirePaymentMethodValue: state.hirePaymentMethod.get('value'),
        hirePaymentMethodValue: '', // Pending from changes in dev.
        imagesById: state.hireCardImageSelector.get('imagesById'),
        immAccountsById: state.accounts.get('byId'),
        immHireCardNameSelector: state.hireCardNameSelector,
        immProfile: state.profile,
        openCreditAplazadoTAE: state.globalVariables.getIn(['variables', 'parameters', 'open_credit', 'aplazado_tae']),
        openCreditAplazadoTIN: state.globalVariables.getIn(['variables', 'parameters', 'open_credit', 'aplazado_tin']),
        premiumAplazadoTAE: state.globalVariables.getIn(['variables', 'parameters', 'pack_premium', 'aplazado_tae']),
        premiumAplazadoTIN: state.globalVariables.getIn(['variables', 'parameters', 'pack_premium', 'aplazado_tin']),
        selectedImageFetchSuccess: state.hireCardImageSelector.get('fetchSuccess'),
        selectedImageId: state.hireCardImageSelector.get('selectedImageId'),
    })
)(OKSummaryHireCard);
